import { useRef, useState } from 'react';
import { Markdown } from '../components/Markdown';

const TOOLS = [
  { label: 'H2', before: '\n## ', after: '\n', block: true },
  { label: 'H3', before: '\n### ', after: '\n', block: true },
  { label: 'Fett', before: '**', after: '**' },
  { label: 'Kursiv', before: '*', after: '*' },
  { label: 'Liste', before: '\n- ', after: '', block: true },
  { label: 'Schritte', before: '\n1. ', after: '', block: true },
];

export function RichEditor({ id, label, value, onChange, rows = 8, hint }) {
  const ref = useRef(null);
  const [preview, setPreview] = useState(false);

  const insert = (before, after) => {
    const el = ref.current;
    if (!el) return;
    const start = el.selectionStart ?? value.length;
    const end = el.selectionEnd ?? value.length;
    const selected = value.slice(start, end);
    const next = value.slice(0, start) + before + selected + after + value.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(start + before.length, start + before.length + selected.length);
    });
  };

  const insertLink = () => {
    const el = ref.current;
    const start = el?.selectionStart ?? value.length;
    const end = el?.selectionEnd ?? value.length;
    const selected = value.slice(start, end) || 'Linktext';
    const url = window.prompt('Link-Ziel (URL):', 'https://');
    if (!url || !url.startsWith('http')) return;
    onChange(value.slice(0, start) + `[${selected}](${url})` + value.slice(end));
  };

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <label htmlFor={id} className="text-sm font-semibold">{label}</label>
        <div className="flex flex-wrap gap-1" role="toolbar" aria-label={`Formatierung für ${label}`}>
          {TOOLS.map((t) => (
            <button key={t.label} type="button" onClick={() => insert(t.before, t.after)} className="min-h-9 rounded-sm border border-brand-brown/25 bg-white px-2.5 text-xs font-bold hover:bg-brand-beige" data-testid={`${id}-tool-${t.label.toLowerCase()}`}>
              {t.label}
            </button>
          ))}
          <button type="button" onClick={insertLink} className="min-h-9 rounded-sm border border-brand-brown/25 bg-white px-2.5 text-xs font-bold hover:bg-brand-beige" data-testid={`${id}-tool-link`}>Link</button>
          <button type="button" onClick={() => setPreview((v) => !v)} aria-pressed={preview} className="min-h-9 rounded-sm border border-brand-olive px-2.5 text-xs font-bold text-brand-olive hover:bg-brand-beige" data-testid={`${id}-preview-toggle`}>
            {preview ? 'Bearbeiten' : 'Vorschau'}
          </button>
        </div>
      </div>
      {preview ? (
        <div className="mt-2 min-h-32 rounded-sm border border-brand-line bg-white p-4" data-testid={`${id}-preview`}>
          <Markdown>{value || '*Noch kein Inhalt*'}</Markdown>
        </div>
      ) : (
        <textarea
          ref={ref}
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={rows}
          className="mt-2 w-full rounded-sm border border-brand-brown/25 bg-white px-3 py-2 font-mono text-sm"
          data-testid={id}
        />
      )}
      {hint && <p className="mt-1 text-xs text-brand-brown-soft">{hint}</p>}
    </div>
  );
}
